import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Input,
  Alert,
  Form,
} from 'reactstrap';
import Select from 'react-select';

const MonthlyReportForm = ({
  reportParams,
  systems,
  sites,
  onChange,
  onSubmit,
  submitting,
  errors,
  selectedSystem,
  selectedSite,
  onSystemChange,
  onSiteChange,
  onTypeChange,
  selectedType,
  typeOptions,
}) => {
  return (
    <Container>
      <Row className="mb-4">
        <Col md={3} />
        <Col md={6}>
          <Form>
            <FormGroup>
              <Label for="typeSelect">Report Type</Label>
              <Select
                name="typeSelect"
                value={selectedType}
                onChange={onTypeChange}
                options={typeOptions}
              />
              {errors.type && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.type}
                </Alert>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="systemSelect">System</Label>
              <Select
                name="systemSelect"
                value={selectedSystem}
                onChange={onSystemChange}
                options={systems}
              />
              {errors.system && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.system}
                </Alert>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="siteSelect">Site</Label>
              <Select
                name="siteSelect"
                value={selectedSite}
                onChange={onSiteChange}
                options={sites}
              />
              {errors.site && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.site}
                </Alert>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="startDate">Start Date</Label>
              <Input
                type="date"
                name="startDate"
                id="startDate"
                value={reportParams.startDate.value}
                onChange={onChange}
              />
              {errors.startDate && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.startDate}
                </Alert>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="endDate">End Date</Label>
              <Input
                type="date"
                name="endDate"
                id="endDate"
                value={reportParams.endDate.value}
                onChange={onChange}
              />
              {errors.endDate && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.endDate}
                </Alert>
              )}
            </FormGroup>

            <FormGroup>
              <Button
                color="primary"
                type="submit"
                disabled={submitting}
                onClick={onSubmit}
                className="mr-2"
              >
                {submitting ? 'Generating' : 'Generate Report'}
              </Button>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

MonthlyReportForm.propTypes = {
  reportParams: PropTypes.object,
};

export default MonthlyReportForm;



// WEBPACK FOOTER //
// ./src/components/reports/MonthlyReportForm.js